import { Button, Icon, Intent, Position, Tooltip } from "@blueprintjs/core"
import { __ } from "src/libs/utilities"
import { ILandingSection, SELECT_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import CheckboxHandler from "./CheckboxHandler"
import Shortcode from "src/libs/useful/shortcode"

/* Protopia Ecosystem component */
export interface ITitleLayerProps {
   section: ILandingSection
}
const TitleLayer = (props: ITitleLayerProps): JSX.Element => {
    const onCheck = () => {

    }
    const onEdit = () => {

    }
    const onRmv = () => {

    }
    return <div className='pe-title-layer-container'> 
        <div className="micro letter-spacing-5 text-center text-light p-1" >
            <div className="text-uppercase smaller title opacity_5">
                {__( "Title and description" )}
            </div>
        </div>

        <div className={`panel-list-button pl-0 pr-1 py-0 `} >
            <Icon icon="blank" className="pl-1 pr-1 pe-surface4 hover " size={13}/>
            <CheckboxHandler 
                onCheck={ onCheck } 
                type={ SELECT_TYPE.TITLE } 
                item={ props.section } 
                sectionId={ props.section.id } 
            /> 
                <Shortcode 
                    className="small text-light text-overflow flex-grow-100 px-1 py-2" 
                    content={ `<span class="title mr-2">${__( "Title" )}:</span> ${ props.section.title.text || "" }` } 
                /> 
            <Tooltip
                content={<div className="small">{__("Edit title")}</div>}
                intent={Intent.PRIMARY}
                position={Position.TOP_RIGHT}
                compact
            >
                <Button variant="minimal" onClick={onEdit} > 
                    <Icon icon="edit" size={9} color="#FFFFFF" />
                </Button>
            </Tooltip> 
            <Tooltip
                content={<div className="small">{__("Remove title")}</div>}
                intent={Intent.PRIMARY}
                position={Position.TOP_RIGHT}
                compact
            >
                <Button variant="minimal" onClick={onRmv} >
                    <i className={ "fas fa-trash"  }></i> 
                </Button>
            </Tooltip>
        </div>
    </div>
}
export default TitleLayer